import React, { useState } from 'react'
import "./home.scss"
import { BsFillCaretLeftFill } from "react-icons/bs";
import { BsFillCaretRightFill } from "react-icons/bs";

import { BsFillBagFill } from "react-icons/bs";
import { BsFillBuildingFill } from "react-icons/bs";
import { BsFillCameraReelsFill } from "react-icons/bs";
import { BsFillCartDashFill } from "react-icons/bs";
import { BsFillCpuFill } from "react-icons/bs";
import { BsFillEmojiHeartEyesFill } from "react-icons/bs";

import { BsFillEmojiAngryFill } from "react-icons/bs";
import { BsFillEmojiDizzyFill } from "react-icons/bs";
import { BsFillEmojiExpressionlessFill } from "react-icons/bs";
import { BsFillEmojiFrownFill } from "react-icons/bs";
import { BsFillEmojiLaughingFill } from "react-icons/bs";

const Home = () => {

  const[swipe, setSwipe]=useState(null)
  const[click, setClick]=useState(1)

  return (
    <div className='home'>
      <div 
        className='sidebar'
        style={{
          width:swipe===true?"7%":""       
        }}
      >
        {
          swipe===true
          ?
          <div className='beforeswipe'>
            <div style={{background:click===1?"#0c6dfd":"", color:click===1?"#fff":""}} onClick={()=>setClick(1)}><BsFillBagFill /></div>
            <div style={{background:click===2?"#0c6dfd":"", color:click===2?"#fff":""}} onClick={()=>setClick(2)}><BsFillBuildingFill /></div>
            <div style={{background:click===3?"#0c6dfd":"", color:click===3?"#fff":""}} onClick={()=>setClick(3)}><BsFillCameraReelsFill /></div>
            <div style={{background:click===4?"#0c6dfd":"", color:click===4?"#fff":""}} onClick={()=>setClick(4)}><BsFillCartDashFill /></div>
            <div style={{background:click===5?"#0c6dfd":"", color:click===5?"#fff":""}} onClick={()=>setClick(5)}><BsFillCpuFill /></div>
            <div style={{background:click===6?"#0c6dfd":"", color:click===6?"#fff":""}} onClick={()=>setClick(6)}><BsFillEmojiHeartEyesFill /></div>
          </div>
          :
          <div className='afterswipe'>
            <div style={{background:click===1?"#0c6dfd":"", color:click===1?"#fff":""}} onClick={()=>setClick(1)}>Testing1</div>
            <div style={{background:click===2?"#0c6dfd":"", color:click===2?"#fff":""}} onClick={()=>setClick(2)}>Testing2</div>
            <div style={{background:click===3?"#0c6dfd":"", color:click===3?"#fff":""}} onClick={()=>setClick(3)}>Testing3</div>
            <div style={{background:click===4?"#0c6dfd":"", color:click===4?"#fff":""}} onClick={()=>setClick(4)}>Testing4</div>
            <div style={{background:click===5?"#0c6dfd":"", color:click===5?"#fff":""}} onClick={()=>setClick(5)}>Testing5</div>
            <div style={{background:click===6?"#0c6dfd":"", color:click===6?"#fff":""}} onClick={()=>setClick(6)}>Testing6</div>
          </div>
        }
      </div>
      <div className='content'>
        {
            click===1
          ? <div><BsFillEmojiAngryFill /></div>
          : click===2
          ? <div><BsFillEmojiDizzyFill /></div>
          : click===3
          ? <div><BsFillEmojiExpressionlessFill /></div>
          : click===4
          ? <div><BsFillEmojiFrownFill /></div>
          : click===5
          ? <div><BsFillEmojiHeartEyesFill /></div>
          : click===6
          ? <div><BsFillEmojiLaughingFill /></div>
          : null
        }
      </div>
      <div 
        className='swipe'
        onClick={()=>{
          setSwipe(!swipe)
        }
        }
        style={{
          left:swipe===true?"5%":""
        }}
      >
        {
          swipe === false
          ? <BsFillCaretRightFill />
          : <BsFillCaretLeftFill />
        }
      </div>
    </div>
  )
}

export default Home
